module.exports = __webpack_public_path__ + "img/half-half.ccd0771.png";